<div class="overwrite-cu-score-action-dialog-wrapper d-flex flex-column gap-3 pt-1 px-2" [formGroup]="form">
	<div class="row g-3">
		<div class="col-6 form-field d-flex flex-column gap-1">
			<label class="field-label mb-0" for="cuScore">CU Score (1–5)</label>
			<p-inputNumber
				inputId="cuScore"
				styleClass="w-100"
				mode="decimal"
				[minFractionDigits]="1"
				[maxFractionDigits]="1"
				[showButtons]="true"
				[min]="1"
				[max]="5"
				formControlName="CUScore"
			></p-inputNumber>
		</div>
		<div class="col-6 form-field d-flex flex-column gap-1">
			<label class="field-label mb-0" for="lpaScore">LPA Score (1–5)</label>
			<p-inputNumber
				inputId="lpaScore"
				styleClass="w-100"
				mode="decimal"
				[minFractionDigits]="1"
				[maxFractionDigits]="1"
				[showButtons]="true"
				[min]="1"
				[max]="5"
				formControlName="LPAScore"
			></p-inputNumber>
		</div>
		<div class="col-6 form-field d-flex flex-column gap-1">
			<label class="field-label mb-0" for="ucdpDocFileId">UCDP Document File Identifier</label>
			<input
				id="ucdpDocFileId"
				type="text"
				class="w-100"
				pInputText
				placeholder="Enter identifier"
				formControlName="UCDPDocFileId"
			/>
		</div>
		<div class="col-6 form-field d-flex flex-column gap-1">
			<label class="field-label mb-0" for="eadDocFileId">EAD Document File Identifier</label>
			<input
				id="eadDocFileId"
				type="text"
				class="w-100"
				pInputText
				placeholder="Enter identifier"
				formControlName="EADDocFileId"
			/>
		</div>
	</div>

	<div class="submission-summary-section">
		<h6 class="mb-3 fw-bold text-dark">Submission Summary Report</h6>
		<div class="row g-3">
			<div class="col-4" *ngFor="let doc of ssrDocuments">
				<div class="upload-card" [class.fileDroped]="!!files[doc.type].blob">
					<span class="upload-card-title">{{ doc.title }}</span>
					<cv-drag-and-drop-file
						class="d-block"
						[message]="files[doc.type].errorMessage"
						[acceptFormat]="'application/pdf'"
						(filesDropped)="onFilesDropped($event, doc.type)"
					></cv-drag-and-drop-file>
				</div>
			</div>
		</div>
	</div>

	<div class="footer-button-wrapper d-flex justify-content-end align-items-center w-100 mt-1 gap-2">
		<button
			pButton
			type="button"
			class="p-button-secondary p-button-outlined"
			(click)="close()"
			label="Close"
		></button>
		<button
			pButton
			type="button"
			class="p-button-primary"
			[disabled]="(form.pristine || !form.valid) && !isThereFilesToUpload"
			(click)="save()"
			label="Save"
		></button>
	</div>
</div>
